import {createContext} from 'react'

const LenguajeContext = createContext()

export default LenguajeContext;